import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { locationChange } from '@Store/navigation/navigation.actions';

const useReferer = (): [string | undefined, () => void] => {
  const dispatch = useDispatch();
  const location = useLocation();
  const redirectUri: string | undefined = location.state?.referer;

  const redirect = () => {
    if (redirectUri) {
      dispatch(locationChange({ path: redirectUri }));
    }
  };

  return [redirectUri, redirect];
};

export default useReferer;
